import { FileInput } from "components/FileInput/FileInput";
import { PersonContact, PersonLegalDTO, Person } from "pages/OfficeAutomation/BaseInformation/PeoplePage/types";
import { useContext, useEffect, useRef, useState } from "react";
import { getTadbirSyncAccDetail, putPicture, setPersonAsync } from '../../../api/api';
import { Button } from "components/Button/Button";
import { Toast } from "components/ToastShow/ToastAlert";
import { Loading } from "components/Loading/loading";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import {  getPerson } from "pages/OfficeAutomation/BaseInformation/PeoplePage/components/api/api";
import { PersonContactList } from "pages/OfficeAutomation/BaseInformation/PeoplePage/components/PersonContactList/PersonContactList";
import { trans } from "utils/helpers";
import "./style.scss";
import { ContactType, MessageType } from "types/enum";
import { Address } from "components/Address/Address";
import { GUID_EMPTY } from "utils/constants";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { ENDPOINTS } from "utils/endpoints";
import { DataGrid } from "components/DataGrid/DataGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { InputLoad } from "components/InputLoading/inputLoading";
import { SelectBox } from "components/Select/Select";

interface PersonLegalFormPropsType {

  handleCancelForm: (cancelBtn: boolean) => void
  idPerson?: any;
  showSaveClose?: any;
  person?: any;
  ButtonInTop?: boolean;

  handleAddPerson: (ans: any) => void,
  mode?: string;
}
export const PersonLegalForm = ({
  showSaveClose=true,
  handleCancelForm,
  ButtonInTop,
  person,
  idPerson,
  handleAddPerson,
  mode
}: PersonLegalFormPropsType) => {
  let personLegalDTO: PersonLegalDTO | undefined, personData: Person, personDataForSend, method;
  let personLegalDTOAddress;
  const [personResponse, setPersonResponse] = useState<Response | any>();

  const [personId, setPersonId] = useState<any>();
  const [resetForm, setResetForm] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>();
  const [showModalContact, setShowModalContact] = useState<boolean>(false);
  const [personContactDataList, setPersonContactDataList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [save_Exit, setSave_Exit] = useState<boolean>(false);
  const [dataChange, setDataChange] = useState(false);
  const [userName, setUserName] = useState<any>("");
  const [userChanges, setUserChanges] = useState<any>({});
  const [dataRecovered, setDataRecovered] = useState<any>({});
  const [showPositionList, setShowPositionList] = useState<boolean>(false);
  const [passowrdInputType,setPasswordInputType]=useState<boolean>(true)
      const [accDetailCodeList,setAccDetailCodeList]=useState<any>([])
    const [accDetailLoading,setAccDetailLoading]=useState(false)
  const [useDefaultPassword, setUseDefaultPassword] = useState<boolean>(true);

  const [Total_records, setTotal_records] = useState<number>(5);
  const formLegalName = useRef<any>(null);



  const changeHandlePic = (e: any) => {
    if (e?.target?.files && e?.target?.files?.length > 0) {
      // setSelectedImage(e.target.files[0]);
      setSelectedImage({url: URL.createObjectURL([...e.target.files][0] )   ,file:[...e.target.files][0]}); 

    }
  };



  async function sendPersonAsync(method , _objData,sendMessage) {
    try{
       const res = await setPersonAsync(method , _objData,sendMessage);
      handleAddPerson(res.data)
      setResetForm(true);
      sessionStorage.setItem("changingforms" , "false");
    /////  localStorage.removeItem("unSavedData")
           const newData=  JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.PersonLegal
            if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
      setUserChanges({})
      setDataRecovered({})
      if (save_Exit) {
        handleCancelForm(true);
      }
      if( mode =="edit" ){
        handleCancelForm(true);
      }
      setDataChange(false)

    }catch(err:any){


    }
  }

  async function sendpersonPictureAsync(id ,  _objData) {
    try {
      const res = await putPicture(id ,  _objData ,true);
  

    } catch (err: any) {
    }
  }



  function sendDataToServer(event) {
    event.preventDefault();
    let data = {
      PersonLegalTitleId: event.target.Title.value,
      LegalName: event.target.LegalName.value,
      LegalNameEN: event.target.LegalNameEN.value,
      RegistryNumber: event.target.RegistryNumber.value.trim()==""?null : event.target.RegistryNumber.value ,
      NationalIdentifier: event.target.NationalIdentifier.value,
      EconNo: event.target.EconNo.value,
      Description: event.target.Description.value,
      LegalType: +event.target.LegalType.value,
      ChiefOfficer: event.target.ChiefOfficer.value,
    };
    let address = (event.target.Address.value||event.target.Plaque.value|| event.target.Unit.value||event.target.PostalCode.value)?   JSON.stringify({ Address: event.target.Address.value, Plaque: event.target.Plaque.value, Unit: event.target.Unit.value, PostalCode: event.target.PostalCode.value, Longitude: event.target.Longitude.value,Latitude: event.target.Latitude.value  }):null;
    let Contact:any=[]
    if(personContactDataList)
    personContactDataList.forEach(item => { if (item.Id != GUID_EMPTY) { Contact.push({ Id:item.Id,Value: item.Value, ContactType: +item.ContactTypeEnum, Description: item.Description }) } })

    let personInfo: (Person|any) = {
      PersonLegalDTO: {
        PersonLegal: data,
        LegalType: +event.target.LegalType.key,
        Email: event.target.Email.value,
        Address: address,
        Phone: event.target.Phone.value,
        Mobile: event.target.Mobile.value

      },
      PersonContacts: Contact,
      UserName:event.target.UserName.value,
      Password:!useDefaultPassword && !personResponse?.data?.Data?.UserName ?event.target.Password.value:undefined,
      AccDetailsId:event.target?.AccDetailsId?.value?event.target?.AccDetailsId?.value:null,


    };
    if (personId) {
      personInfo.Id=personId
      personDataForSend = personInfo
      method = "put";
      // var _objData = new FormData();
      // _objData.append("PersonDTO", JSON.stringify(personDataForSend));
      if(selectedImage){
          let personPicture = new FormData();
          personPicture.append("personPicture", selectedImage?.file);
          sendpersonPictureAsync( personResponse.data.Data.PersonLegalDTO.PersonLegal.Id, personPicture)
      }
      sendPersonAsync(method ,personDataForSend,null )
    } else {
      personDataForSend = personInfo;
      method = "post";
      var _objData = new FormData();
      _objData.append("PersonDTO", JSON.stringify(personDataForSend));
      if(selectedImage){
          _objData.append("PersonPicture", selectedImage?.file);
      }
      sendPersonAsync(method ,_objData, event.target.sendMessage.checked)
    }

  }




  const getTadbirSyncAccDetailAsync=async(fn=formLegalName.current?.LegalName?.value)=>{
    setAccDetailLoading(false)
    try{
      let firstName=fn
      if(firstName && firstName!=" "){


      const {data}=await getTadbirSyncAccDetail(firstName)
      setAccDetailCodeList(data.Data)
    setAccDetailLoading(true)}
      
    }catch{}
  }




  function dataURLtoFile(dataurl, filename) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
  }
  
    async function getDataAsync(Id) {
      setLoading(false)
      setSelectedImage(null)
      
      try {
        let response = await getPerson(Id);
        if(person){
          response = person;
          
        }else{
           response = await getPerson(Id);

        }
        
        setPersonResponse(response);  
      if(mode=='edit') getTadbirSyncAccDetailAsync(response.data.Data.PersonLegalDTO.PersonLegal?.LegalName)
      //  setSelectedImage(response.data.Data.PersonLegalDTO.PersonLegal?.PersonLegalPicture)
      let contact = response.data.Data?.PersonContacts.map(item => {
   
        return {
          Id: item.Id,
          ContactTypeEnum: item.ContactType ,
          Description: item.Description,
          ContactType: trans(ContactType[item.ContactType]) ,
          Value: item.Value
        }
      })
      setPersonContactDataList(contact);
      if(response.data.Data.PersonLegalDTO.PersonLegal?.PersonLegalPicture){
        let file = dataURLtoFile('data:image/png;base64,'+response.data.Data.PersonLegalDTO.PersonLegal?.PersonLegalPicture , "1.jpg")
        // setSelectedImage(file)
        setSelectedImage({url: URL.createObjectURL(file)   ,file:file}); 

  
      }
        sessionStorage.setItem("changingforms" , "false")
            const newData=  JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.PersonLegal
          if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
       } catch (error) {
         
       }

       setLoading(true)
    }

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = '';
  };
  
  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
      setSelectedImage(null)
    }
  }, [resetForm]);


  useEffect(() => {
    if(userChanges!=undefined&& Object.values(userChanges).filter((item)=>item!=null).length>0){
        sessionStorage.setItem("changingforms" , "true")
        
        let forms:any=JSON.parse(localStorage.getItem("unSavedData" )+"")??{}
        forms ={...forms ,  "PersonLegal" :{...userChanges , Id:idPerson } }
        localStorage.setItem("unSavedData" , JSON.stringify(forms))
          window.addEventListener('beforeunload', handleBeforeUnload);
          return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
          };
    }else{
        if(userChanges!=undefined && Object.keys(userChanges).length >0){
          sessionStorage.setItem("changingforms" , "false")
             const newData=  JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.PersonLegal
          if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
          window.removeEventListener('beforeunload', handleBeforeUnload);

        }
    }

}, [userChanges]);

  useEffect(() => {
    if (sessionStorage.getItem("changingforms")=="true"&&localStorage.getItem("unSavedData")!=null){
      let forms = JSON.parse(localStorage.getItem("unSavedData")+"") ??{}
      if(forms){
        setDataRecovered(forms["PersonLegal"])
        setUserChanges(forms["PersonLegal"])

      }
    }
    if (idPerson) {
      if(mode != "create"){
        if(dataChange){
          // Toast(trans("modalclosemessage") , "warning" , "alert" , ()=>{setPersonId(idPerson);getDataAsync(idPerson)})
          Toast(trans("modalclosemessage") , MessageType.confirm , ()=>{setPersonId(idPerson);getDataAsync(idPerson)})

        }else{
          setPersonId(idPerson)
          getDataAsync(idPerson)
        }
      }
    }else if(mode == "create"){
      setPersonId(null)
      setResetForm(true);

    }
  }, [idPerson , mode]);
   
  if (idPerson && personResponse ) {
    personData = Object.assign({}, personResponse.data.Data);
    personLegalDTO = personData.PersonLegalDTO;
    personLegalDTO&& (personLegalDTO.Positions = personData.Positions)
    try {
      if (typeof (personData.PersonLegalDTO?.Address) === "string")
      personLegalDTOAddress = JSON.parse(personData?.PersonLegalDTO?.Address)
    } catch {
      personLegalDTOAddress = personData.PersonLegalDTO?.Address
    }
  } else {
    personLegalDTO = undefined;
  }

  const personContactDataListCallback = (ans: PersonContact[]) => {
    if(ans.length!=personResponse?.PersonContacts?.length){

      setUserChanges({...userChanges , ...{PersonContact: ans}})
    }else{
      setUserChanges({...userChanges , ...{PersonContact: null}})
    }
    setPersonContactDataList(ans);
  }
  const handleBtnContact = () => {
    setShowModalContact(true);
    
  }

  return (
    <div className="col-lg-12 mb-1">
      <div className=" border-top-0">
        <div className="card-body">
          {
            loading ?

          <form  id="PersonLegalForm" ref={formLegalName} onSubmit={sendDataToServer}>
                   {ButtonInTop&&
                  <div className="col-lg-12 mb-1 btns_form">
                    {mode !== "view" ? <>
                      {(!personId&&showSaveClose) && <Button
                        btnType="submit"
                        value="SaveAndClose"
                        onClick={() => { setSave_Exit(true) }}
                      />}
                      <Button form="PersonLegalForm" value="Save" btnType="submit" />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          if(sessionStorage.getItem("changingforms")+""=="true"){
                            // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
                            //     sessionStorage.setItem("changingforms" , "false");
                            //     setUserChanges({});
                            //     handleCancelForm(true)
                            // });
                            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
                              sessionStorage.setItem("changingforms" , "false");
                              setUserChanges({});
                              handleCancelForm(true)
                          });
                        }else{
                          handleCancelForm(true)
                         };
                          
                        }}
                      />
                    </>
                      :
                      <Button
                        btnType="primary"
                        value="Close"
                        onClick={() => handleCancelForm(true)}
                      />
                    }

                  </div>
                  }
            <div className="card ">
            <div className="row p-3">
              
            <div className="col-lg-3  col-sm-4  mt-1">
              <DictionarySelectBox
              recordedData={personLegalDTO?.PersonLegal?.PersonLegalTitleId} 
              mode={mode} 
              Change={(e)=>{setUserChanges({...userChanges , ...e})}} 
              value={dataRecovered?.Title ? dataRecovered?.Title  :personLegalDTO?.PersonLegal?.PersonLegalTitleId} 
              name="Title"
              label="Title"
              endPoint={ENDPOINTS.BaseInformation.PersonLegalTitle.dictionary}
               />
            </div>
            <div className="col-lg-3 col-sm-4 mt-1">
              <Textbox
                Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                textboxType="text"
                textboxName="LegalName"
                labelText="LegalName"
                maxLength={100}
                required={true}
                recordedData={personLegalDTO?.PersonLegal?.LegalName}
                defaultValue={dataRecovered?.LegalName ? dataRecovered?.LegalName  :personLegalDTO?.PersonLegal?.LegalName}
                resetForm={resetForm}
                mode={mode}
                 onBlurHandler={()=>{getTadbirSyncAccDetailAsync()}}
              />
            </div>
            <div className="col-lg-3 col-sm-4 mt-1">
              <Textbox
                Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                textboxType="text"
                textboxName="LegalNameEN"
                labelText="LegalNameEN"
                maxLength={100}
                fixedLanguage={"en"}
                recordedData={personLegalDTO?.PersonLegal?.LegalNameEN}
                defaultValue={dataRecovered?.LegalNameEN ? dataRecovered?.LegalNameEN  :personLegalDTO?.PersonLegal?.LegalNameEN}
                resetForm={resetForm}
                mode={mode}
              />
            </div>
            <div className="col-lg-3 col-sm-4 mt-1">
              <EnumerationTypeSelect
              recordedData={personLegalDTO?.PersonLegal?.LegalType}
              label="Legaltype"
              enumTypeSelect="Legaltype" 
              Change={(e)=>{setUserChanges({...userChanges , ...e})}} 
              mode={mode} 
              value={dataRecovered?.LegalType ? dataRecovered?.LegalType  :personLegalDTO?.PersonLegal?.LegalType} 
              name="LegalType" 
              />
            </div>
            <div className="col-lg-3 col-sm-4 mt-1">
              <Textbox
                Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                textboxType="nationalIdentifier"
                textboxName="NationalIdentifier"
                labelText="NationalIdentifier"
                maxLength={14}
                recordedData={personLegalDTO?.PersonLegal?.NationalIdentifier}
                defaultValue={dataRecovered?.NationalIdentifier ? dataRecovered?.NationalIdentifier  :personLegalDTO?.PersonLegal?.NationalIdentifier}
                resetForm={resetForm}
                mode={mode}
              />
            </div>





                  <div className="col-9 row col-sm-4 col-md-3 mt-1 align-items-start ">
{ mode!='view'?<div className="col-12">
          { accDetailLoading?    <SelectBox
                onChange={(e) => {
               
                }}
                
                mode={ !accDetailCodeList?.length ?'view':mode}
                lable="detailcode"
                selectType="select"
                value={personResponse?.data?.Data?.AccDetailsId}
                options={!!accDetailCodeList?.length?['',...accDetailCodeList.map(item=>item?.Description)]:[]}
                val={!!accDetailCodeList?.length?[null,...accDetailCodeList.map(item=>item?.Guid)]:[]}
                name={'AccDetailsId'}
                />
              
              :
              <div className="">
                <InputLoad
                labelText="detailcode"

          onClick={getTadbirSyncAccDetailAsync}
 

        />
          

              </div>
      
              }
             
                  </div>
                :
                  <Textbox
                Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                textboxType="text"
                textboxName="detailcode"
                labelText="detailcode"
                defaultValue={personResponse?.data?.Data?.AccDetailCode}
                resetForm={resetForm}
                mode={mode}
              /> 
                }


</div>





            <div className="col-lg-3 col-sm-4 mt-1">
              <Textbox
                Change={(e)=>{setUserChanges({...userChanges , ...e})}}    
                textboxType="econNo"
                textboxName="EconNo"
                labelText="EconNo"
                maxLength={25}
                recordedData={personLegalDTO?.PersonLegal?.EconNo}
                defaultValue={dataRecovered?.EconNo ? dataRecovered?.EconNo  :personLegalDTO?.PersonLegal?.EconNo}
                resetForm={resetForm}
                  mode={mode}
              />
            </div>
            <div className="col-lg-3 col-sm-4 mt-1">
              <Textbox
              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                textboxType="text"
                textboxName="ChiefOfficer"
                labelText="ChiefOfficer"
                recordedData={personLegalDTO?.PersonLegal?.ChiefOfficer}
                defaultValue={dataRecovered?.ChiefOfficer ? dataRecovered?.ChiefOfficer  :personLegalDTO?.PersonLegal?.ChiefOfficer}
                resetForm={resetForm}
                  mode={mode}
              />
            </div>
            <div className="col-lg-3 col-sm-4 mt-1">
              <Textbox
              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                textboxType="RegistryNumber"
                textboxName="RegistryNumber"
                labelText="RegistryNumber"
                recordedData={personLegalDTO?.PersonLegal?.RegistryNumber}
                defaultValue={dataRecovered?.RegistryNumber ? dataRecovered?.RegistryNumber  :personLegalDTO?.PersonLegal?.RegistryNumber}
                resetForm={resetForm}
                  mode={mode}
              />
            </div>
            <div style={{ height: "140px" }} className="col-12 mt-1 mb-5">
              <FileInput
              
                showBox={true}
                maxWidth={1000}
                maxHeight={1000}
                maxSize={10000000000}
                hideSrc={false}
                accept=".jpg,.png"
                resetForm={resetForm}
                mode={mode}
                lable="PersonLegalPicture"
                name="PersonLegalPicture"
                defultFileName="PersonLegalPicture.jpg"
                onChange={changeHandlePic}
                src={selectedImage ? selectedImage?.url :(personLegalDTO?.PersonLegal?.PersonLegalPicture?'data:image/png;base64,'+personLegalDTO.PersonLegal.PersonLegalPicture:'')}	
                />
            </div>
            <div className="col-lg-6 mt-1 mb-4">
              <Textbox
              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                textboxType="text"
                textboxName="Description"
                labelText="Description"
                maxLength={900}
                recordedData={personLegalDTO?.PersonLegal?.Description}
                defaultValue={dataRecovered?.Description ? dataRecovered?.Description  :personLegalDTO?.PersonLegal?.Description}
                resetForm={resetForm}
                  mode={mode}
              />
            </div>
              </div>
            </div>
            <div className="card p-3">
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                    <>

                    <Address personContact={mode=="create"? null : personLegalDTOAddress } mode={mode}/>


                </>
                <div className="row align-items-center">
                <div className="col-lg-2 col-sm-4 mt-1">
                  <Textbox
                  required={true}
                  Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                    textboxType="text"
                    textboxName="Phone"
                    labelText="Phone"
                    recordedData={personLegalDTO?.Phone}
                    defaultValue={dataRecovered?.Phone ? dataRecovered?.Phone  :personLegalDTO?.Phone}
                    resetForm={resetForm}
                      mode={mode}
                  />
                </div> 
                <div className="col-lg-2 col-xxl-2 col-sm-6 mt-1">
                  <Textbox
                    Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                    mode={mode}
                    textboxType="mobile"
                    textboxName="Mobile"
                    labelText="Mobile"
                    maxLength={11}
                    recordedData={personLegalDTO?.Mobile}
                    defaultValue={dataRecovered?.Mobile ? dataRecovered?.Mobile  :   personLegalDTO?.Mobile}
                    resetForm={resetForm}
                  />
                </div>
                <div className="w-100"></div>
                { mode=='create'   &&  <div  className="col-auto " dir="rtl">
                                            <CheckableButton
                                              labelText={"sendMessage"}
                                              inputName={"sendMessage"}
                                              type="checkbox"
                                              // defaultChecked={useDefaultPassword}
                                              // onchange={(e) => {
                                              //   setUseDefaultPassword(e);
                                              // }}
                                            />
                                            </div>}
                <div className="col-lg-3 col-sm-6 mt-1 ">
                  <Textbox
                      mode={mode}
                      recordedData={personResponse?.data?.Data?.UserName}
                      defaultValue={dataRecovered?.UserName ? dataRecovered?.UserName  :personResponse?.data?.Data?.UserName}
                      Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                      onChange={(e)=>{setUserName(e.target.value)}}
                      textboxType="userName"
                      resetForm={resetForm}
                      required={personResponse?.data?.Data?.UserName?true:false}
                      textboxName="UserName"
                      labelText="UserName"
                  />
                </div>






{
                          
                          !personResponse?.data?.Data?.UserName && mode!='view'?
                          <div className={`${!useDefaultPassword?'col-lg-5':'col-lg-auto'} row align-items-center col-10 mt-lg-4  mb-3`}>
                                                  <div className={`${!useDefaultPassword?'col-5':'col-12'}`} dir="rtl">
                                            <CheckableButton
                                              labelText={"UseDefaultPassword"}
                                              inputName={"UseDefaultPassword"}
                                              type="checkbox"
                                              defaultChecked={useDefaultPassword}
                                              onchange={(e) => {
                                                setUseDefaultPassword(e);
                                              }}
                                            />
                                            </div>
                                              {!useDefaultPassword && (
                                              <div className="col-12 col-sm-7 ">
                                              <div className="input-group d-flex align-items-center" dir="ltr">
                                                <div className="input-group-prepend " style={{height:'27.5px',marginTop:'4.5px'}} dir="ltr">
                                                  <button
                                                    disabled={mode == "view"}
                                                    onClick={() =>
                                                      setPasswordInputType(!passowrdInputType)
                                                    }
                                                    className="btn btn-sm btn-outline-secondary h-100 d-flex align-items-center justify-content-center"
                                                    type="button"
                                                  >
                                                    {passowrdInputType ? (
                                                      <FontAwesomeIcon
                                                        className=""
                                                        icon={["fas", "eye"]}
                                                      ></FontAwesomeIcon>
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className=""
                                                        icon={["fas", "eye-slash"]}
                                                      ></FontAwesomeIcon>
                                                    )}
                                                  </button>
                                                </div>
                                              <div className="col-9">
 <Textbox
                                                  textboxName="Password"
                                                  textboxType={passowrdInputType ? "password" : "text"}
                                                  // className="form-control"
                                                  minLength={ 6}
                                                  maxLength={ 10}
                      resetForm={resetForm}

                                                  readonly={mode == "view"}
                                                />
                                             
                                              </div>
                                               
                                               
                                              </div>
                          
                                              </div>
                                            )}
                                 
                                          </div>
                          :<></>
                          
                                          }

                <div className="col-lg-3 col-sm-4 mt-1">
                  <Textbox
                    Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                    required={userName.length > 0}
                    recordedData={personLegalDTO?.Email}
                    textboxType="text"
                    textboxName="Email"
                    labelText="Email"
                    defaultValue={dataRecovered?.Email ? dataRecovered?.Email  :personLegalDTO?.Email}
                    resetForm={resetForm}
                    mode={mode}
                  />
                </div>
          
                </div>
                <div
                  className="col-lg-2 mt-lg-1 btn_contacts"
                  style={{ paddingTop: "21px",direction:"ltr" }}
                >
                  <Button
              
                    btnType="primary"
                    value="Contacts"
                    onClick={handleBtnContact}
                  />
                </div>
                {( personLegalDTO?.Positions.length > 0&& mode!="create")&& 
                     <div
                      className="col-lg-2 col-xxl-1 mt-lg-1 btn_contacts"
                      style={{ paddingTop: "21px",direction:"ltr" }}
                    >
                      <Button
                        btnType="primary"
                        value="positions"
                        onClick={(e)=>{setShowPositionList(true)}}
                      />
                    </div>}
                  </div>
                </div>
              </div>
             </div>
            {!ButtonInTop&&
            <div className="col-lg-12 mt-1 btns_form">
            { mode !=="view" ? <>
                                {(!personId&&showSaveClose) && <Button
                  btnType="submit"
                  value="SaveAndClose"
                  onClick={()=>{setSave_Exit(true)}}
                />}
                <Button value="Save" btnType="submit" />
                <Button
                  btnType="cancel"
                  value="Cancel"
                  onClick={() =>{
                    if(sessionStorage.getItem("changingforms")+""=="true"){
                      // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
                      //     sessionStorage.setItem("changingforms" , "false");
                      //     setUserChanges({});
                      //     handleCancelForm(true)
                      // });
                      Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
                        sessionStorage.setItem("changingforms" , "false");
                        setUserChanges({});
                        handleCancelForm(true)
                    });
                  }else{
                    handleCancelForm(true)
                   };
                    
                }}
                />
                </>
                :

                 <Button
                  btnType="primary"
                  value="Close"
                  onClick={() => handleCancelForm(true)}
                />
                }
            </div> 
            }    
          </form>
            :<Loading/>
          }

        </div>
      </div>
      {showModalContact && 
      <ModalForm
        checkClose={false}
        mode={mode}
        onHide={() => setShowModalContact(false)}
        show={showModalContact}
        title="PersonContact"
      >
        <PersonContactList
              mode={mode}
              personId={personId}
              TotalRecords={Total_records}
              personContactDataListProp={dataRecovered?.PersonContact ? dataRecovered?.PersonContact  :personContactDataList}
              personContactDataListCallback={personContactDataListCallback}
        />
        <div className="modal-msg__btn-wrapper mt-2"></div>
      </ModalForm>
      }
        {showPositionList &&
          <ModalForm
            checkClose={false}
            onHide={() => setShowPositionList(false)}
            show={showPositionList}
            title="Positions"
          >
              <div >
                {(personLegalDTO&&personLegalDTO?.Positions )&&
                
                <DataGrid
                parentName={"PersonPositions"}
                theadData={Object.keys(personLegalDTO?.Positions[0]) }
                minCellWidth={80}
                startIndex={7}
                useLanguage={true}
                tbodyData={personLegalDTO?.Positions}
                selectedRowObjectCallback={(e)=>{}}  
                />
              }
              </div>

          </ModalForm>
        }
    </div>
  );
};
